import React from 'react';
import CostForm from "../../forms/CostForm";
import moment from "moment";
import {Button} from "react-materialize";
import * as utils from "../../../utils/utils";
import * as creationActions from "../../../actions/creation";

export default class CostItem extends React.Component {
    render() {
        return (
            <tr>
                <td>{utils.notNullNorUndefined(this.props.item.company)? this.props.item.company.name : ''}</td>
                {/*<td>{this.props.item.currency.name}</td>*/}
                <td>{utils.notNullNorUndefined(this.props.item.creationDate) && moment.unix(this.props.item.creationDate).format('DD/MM/Y')}</td>
                <td>{this.props.item.invoiceNumber}</td>
                <td>{this.props.item.label}</td>
                <td>{utils.money(this.props.item.totalCost, this.props.currency)}</td>
                <td><Button floating onClick={() => this.props.openDrawer(CostForm, {item: this.props.item, fog: this.props.fog}, creationActions.destroyingnewlyCreatedCost())} icon="edit" className="edit-button" /></td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/cost/CostItem.js